import { FormattedNumber } from '@cmg/i18n';
import React from 'react';

import { FilingType } from '../../../../../../../graphql';
import {
  OfferingDetails_PublishedOffering_FilingsFragment,
  OfferingDetails_PublishedOfferingFragment,
} from '../../../../../../offering-side-panel/offering-details/graphql/__generated__';
import { KeyValuePair } from '../../../../KeyValuePair';

type IpoPricePairProps = {
  latestFilling?: OfferingDetails_PublishedOffering_FilingsFragment;
  pricingCurrencyCode: OfferingDetails_PublishedOfferingFragment['pricingCurrencyCode'];
};

export function IpoPricePair({ latestFilling, pricingCurrencyCode }: Readonly<IpoPricePairProps>) {
  if (latestFilling?.filingType === FilingType.Final) {
    return (
      <KeyValuePair
        label="Offering Price"
        value={
          <FormattedNumber
            value={latestFilling.offerPrice}
            format="currency"
            currency={pricingCurrencyCode}
          />
        }
      />
    );
  }

  if (latestFilling?.ipoRangeLow && latestFilling.ipoRangeHigh) {
    return (
      <KeyValuePair
        label="Price Range"
        value={
          <React.Fragment>
            <FormattedNumber
              value={latestFilling.ipoRangeLow}
              format="currency"
              currency={pricingCurrencyCode}
              emptyValueLabel=""
            />
            –
            <FormattedNumber
              value={latestFilling.ipoRangeHigh}
              format="currency"
              currency={pricingCurrencyCode}
              emptyValueLabel=""
            />
          </React.Fragment>
        }
      />
    );
  }

  return <KeyValuePair label="Price Range" value="-" />;
}
